import React, { useState } from "react";
import * as RB from "react-bootstrap";
import Swal from "sweetalert2";
import * as utils from "../../Utils/comman";

const UpdateAllCouponsModal = ({ show, setShowUpdateModal,getCouponList }) => {
  const [expireInDays, setExpireInDays] = useState("");

  const onClose = () => {
    setShowUpdateModal(false);
    setExpireInDays("")
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setExpireInDays(value);
    }
  };

  const handleConfirmUpdate = () => {
  
    Swal.fire({
      title: "Are you sure?",
      text: "This will update all expired coupons. Do you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "No, Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // Replace with real API logic
        updateAllExpiredCoupons();
      } else {
        onClose();
      }
    });
  };

  const updateAllExpiredCoupons = () => {
    // onclose();
    // setExpireInDays("");
    var bodyFormData = new FormData();

    bodyFormData.append("ids", "all");
    bodyFormData.append("expire_in_months", expireInDays);
    utils
      .callAPI("post", `/Coupon/edit-multiple`, bodyFormData)
      .then((res) => {
        getCouponList()
        onClose();
      })
      .catch((err) => {});
  };

  return (
    <RB.Modal show={show} onHide={onClose}>
      <RB.Modal.Header closeButton>
        <RB.Modal.Title>Update All Expire Coupons</RB.Modal.Title>
      </RB.Modal.Header>
      <RB.Modal.Body>
        <div className="mb-3">
          <RB.FloatingLabel className="floating-label-fancy">
            <RB.InputGroup hasValidation>
              <RB.Form.Control
                type="text"
                name="expireInDays"
                placeholder="Expire in"
                value={expireInDays}
                onChange={handleInputChange}
                required
              />
              <RB.InputGroup.Text className="border-end-0 border-top-0">
                Month
              </RB.InputGroup.Text>
              <RB.Form.Control.Feedback type="invalid">
                Please enter expiry in months.
              </RB.Form.Control.Feedback>
            </RB.InputGroup>
          </RB.FloatingLabel>
        </div>
      </RB.Modal.Body>
      <RB.Modal.Footer>
        <RB.Button variant="secondary" onClick={onClose}>
          Cancel
        </RB.Button>
        <RB.Button
          variant="primary"
          disabled={!expireInDays}
          onClick={handleConfirmUpdate}
        >
          Update
        </RB.Button>
      </RB.Modal.Footer>
    </RB.Modal>
  );
};

export default UpdateAllCouponsModal;
